/**
 * Yield Event Types and API
 *
 * This file contains type definitions and API client for yield events.
 */

import {
  CROP_YIELD_TYPE,
  GRASS_YIELD_TYPES,
  MACHINERY,
  YIELD_TYPES,
} from "./commonTypes";

export const YIELD_EVENT_REJECTION_PERIOD_DAYS = 30;

export enum GRASS_UNITS {
  KG = "KG",
  TONNE = "TONNE",
}

export enum CROP_UNITS {
  KG = "KG",
  TONNE = "TONNE",
}

export enum MILK_UNITS {
  LITRE = "LITRE",
  M3 = "M3",
}

export enum MEAT_UNITS {
  KG = "KG",
  TONNE = "TONNE",
}

export enum SOLD_OR_KEPT {
  SOLD = "SOLD",
  KEPT = "KEPT",
}

export enum REVENUE_CURRENCY {
  GBP = "GBP",
}

export type GrassYieldAmount = {
  unitType: GRASS_UNITS;
  amount: number;
  soldOrKept: SOLD_OR_KEPT;
  grassYieldType: GRASS_YIELD_TYPES;
  revenue?: number;
  revenueCurrency?: REVENUE_CURRENCY;
};

export type GrassYieldDetails = {
  yieldType: YIELD_TYPES.GRASS;
  yieldAmounts: GrassYieldAmount[];
  fieldGuids: string[];
};

export type CropYieldAmount = {
  unitType: CROP_UNITS;
  amount: number;
  soldOrKept: SOLD_OR_KEPT;
  cropYieldType: CROP_YIELD_TYPE;
  revenue?: number;
  revenueCurrency?: REVENUE_CURRENCY;
};

export type CropYieldDetails = {
  yieldType: YIELD_TYPES.CROP;
  yieldAmounts: CropYieldAmount[];
  fieldGuids: string[];
};

export type MilkYieldAmount = {
  unitType: MILK_UNITS;
  amount: number;
  soldOrKept: SOLD_OR_KEPT;
  revenue?: number;
  revenueCurrency?: REVENUE_CURRENCY;
};

export type MilkYieldDetails = {
  yieldType: YIELD_TYPES.MILK;
  yieldAmounts: MilkYieldAmount[];
  animalGroupGuids: string[];
};

export type MeatYieldAmount = {
  unitType: MEAT_UNITS;
  amount: number;
  soldOrKept: SOLD_OR_KEPT;
  revenue?: number;
  revenueCurrency?: REVENUE_CURRENCY;
};

export type MeatYieldDetails = {
  yieldType: YIELD_TYPES.MEAT;
  yieldAmounts: MeatYieldAmount[];
  animalGroupGuids: string[];
};

export type YieldEvent = {
  creationDate?: string;
  guid: string;
  yieldEventDate: string;
  note?: string;
  fuel?: number;
  operationalCost?: number;
  operationalCostUnit?: string;
  machinery?: MACHINERY[];
  yieldDetails:
    | GrassYieldDetails
    | MilkYieldDetails
    | MeatYieldDetails
    | CropYieldDetails;
};
